import { SyntheticEvent } from 'react';

export const suppressEvents = (e: SyntheticEvent) => {
  e.stopPropagation();
  e.preventDefault();
};
